module.exports = __webpack_public_path__ + "img/logo.8dde9195.png";